import { bridge } from '../../../bridge';
import { isWeb } from '../../../isWeb';

/**
 * - 추천탭(홈 안의 상단탭)으로 이동
 */
export const moveToToday = () => {
  if (isWeb) {
    // `/today` 는 홈 상단탭 `selected` 로 풀려 추천탭이 고정된다(`/` 는 서버 기본탭).
    // resolveWebURL 은 `/today` 가 WEB_ROUTE_PATHS 에 없어 레거시 웹으로 내보낸다.
    location.href = '/today';
    return;
  }
  bridge.openPath('/home/today');
};
